import React, { useContext } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { AuthContext } from '../context/AuthContext';

/**
 * PublicRoute allows both authenticated and unauthenticated users to access the page
 * No redirect happens - the page is accessible to everyone
 */
const PublicRoute = ({ children }) => {
  // const { isLoaded } = useAuth();
  
  // Using AuthContext instead of Clerk
  const { loading } = useContext(AuthContext);

  // Show loading while auth is initializing
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f9fafc',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  // Allow access regardless of authentication status
  return <>{children}</>;
};

export default PublicRoute;
